import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogFooter,
  DialogClose,
} from "@/components/Dialog";
import { FILTER_CATEGORIES } from "@/components/Search/constants";
import ModalAccordionItem from "./ModalAccordionItem";
import RecentlyAddedAccordionItem from "./RecentlyAddedAccordionItem";
import { useClearRefinements } from "react-instantsearch";
import useHandleSearchParams from "@/hooks/useHandleSearchParams";
import { ReactNode } from "react";
import * as Accordion from "@radix-ui/react-accordion";
import { useProductCreatedRange } from "../SearchContextProvider";
import useRefinementExcludedAttributes from "../../hooks/useRefinementExcludedAttributes";
import useTranslations from "@/i18n/useTranslations";

const SearchFilterModal = ({
  children,
  triggerClassName,
  selectedCategory,
}: {
  children: ReactNode;
  triggerClassName?: string;
  selectedCategory?: string;
}) => {
  const t = useTranslations("Common");
  const { clearSearchParamsExceptQuery } = useHandleSearchParams();
  const excludedAttributes = useRefinementExcludedAttributes();
  const { refine: clearAllRefinements } = useClearRefinements({
    excludedAttributes: excludedAttributes,
  });
  const { clearProductCreatedRange } = useProductCreatedRange();

  const handleClearAll = () => {
    clearAllRefinements();
    clearSearchParamsExceptQuery();
    clearProductCreatedRange();
  };

  return (
    <Dialog>
      <DialogTrigger className={triggerClassName}>{children}</DialogTrigger>
      <DialogContent className="p-0 gap-0 max-w-full h-full lg:!h-modal lg:max-w-3xl">
        <div className="flex flex-col h-full w-full ">
          <DialogHeader className="p-3 !text-left !sm:text-left border-b">
            <h2 className="text-xl m-0 pl-3">{t("allFilters")}</h2>
          </DialogHeader>

          <div className="flex-1 overflow-y-auto">
            <Accordion.Root
              type="single"
              collapsible
              defaultValue={selectedCategory}
              className="px-0"
            >
              <div className="h-auto- overflow-y-auto px-0 overflow-x-hidden">
                {FILTER_CATEGORIES.map((filterCategory) => (
                  <ModalAccordionItem
                    key={filterCategory}
                    filterCategory={filterCategory}
                  />
                ))}
                <RecentlyAddedAccordionItem />
              </div>
            </Accordion.Root>
          </div>

          <DialogFooter className="flex flex-row flex-row-reverse h-18 p-4 border-t-2">
            <DialogClose className="gap-4 w-full h-full flex justify-end">
              <button
                className="py-2 bg-white text-sm text-brand shadow border-2 border-brand hover:bg-brand hover:text-white !h-auto px-4 rounded-md"
                onClick={handleClearAll}
              >
                Clear all
              </button>
              <button
                className="text-white bg-brand text-sm md:w-auto hover:bg-white 
              hover:text-brand border-2 border-brand px-4 rounded-md py-2"
              >
                Apply
              </button>
            </DialogClose>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SearchFilterModal;
